import { ProcesarDatosApi } from "../api/ApiFetch";
const controlador = "Notificaciones";

export const ObtenerFechaVencimiento = async (idUsuario) => {
    const url = `${controlador}/ObtenerFechaVencimiento/${idUsuario}`;

    return await ProcesarDatosApi('GET', url);
}